import classnames from 'classnames';

const OverlayText = ({ overlay }) => {
    const { contentParams } = overlay;

    const classes = classnames('overlay-text', contentParams.theme);

    return (
        <div className={classes}>
            <div className="overlay-text__content">
                {contentParams.title ? (
                    <h4 className="overlay-text__title" dangerouslySetInnerHTML={{__html: contentParams.title}}/>
                ) : null}
                {contentParams.text ? (
                    <p className="overlay-text__paragraph" dangerouslySetInnerHTML={{__html: contentParams.text}} />
                ) : null}
            </div>
        </div>
    )
}

export default OverlayText
